export const TITLE = "千里马招标网";
const isProd = process.env.VUE_APP_SERVER_ENV === "prod";
// 千里马招标网首页
export const INDEX_URL = "/";
// 老的1.0域名
export const OLD_DOMAIN_NAME_URL = "//www.qianlima.com";
//2.0招标详情页;
export const OLD_TENDER_DETAIL = process.env.VUE_APP_OLD_DETAIL_URL;
// 2.0 搜索页面
export const VUE_APP_NEW_SEARCH_URL = process.env.VUE_APP_NEW_SEARCH_URL;
//2.0会员中心
export const VUE_APP_OLD_USER_CENTER_URL = process.env.VUE_APP_OLD_USER_CENTER_URL;

export const BEIJING_ICP_CERTIFICATE_URL = "https://beian.miit.gov.cn/"; // 京ICP证160587号
export const BEIJING_PUBLIC_NETWORK = "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802022728"; //京公网安备 11010802022728号
// WAP域名地址
export const WAP_DOMAIN_URL = "https://wap.qianlima.com/";
export const ossPath =
  process.env.VUE_APP_SERVER_ENV === "test" ? "//gw-static-test.qianlima.com" : "//gw-static.qianlima.com";
export const imgPath = ossPath + "/0cdn/static/front/qlmBidding_static_template/img";
export const INDEX_URL_GJXX = isProd ? "https://www.qianlima.com" : `https://seo.atest.qianlima.com`;
// 登录地址
export const TOLOGIN_URL = VUE_APP_OLD_USER_CENTER_URL + "/login.html";
// 注册地址
export const REGISTER_URL = VUE_APP_OLD_USER_CENTER_URL + "/register.html?a=2";
export const SEARCH_URL = isProd ? "https://search.qianlima.com" : `https://service.atest.qianlima.com`;
// 咨询热线
export const SERVICE_PHONE = "400-688-2000";
export const SERVICE_PHONE_HOT = "400-077-0023";
export const WAP_INDEX_URL = isProd ? "https://wap.qianlima.com" : `https://wap.atest.qianlima.com`;
export const PHONE_WEBCHAT_URL = isProd
  ? "https://customer.qianlima.com/sale_before"
  : "https://api.atest.qianlima.com/customer/sale_before"
